export default __webpack_public_path__ + "static/media/FullStar.52bcf31b.svg";